import type { FC } from 'react';
import { InterfaceAbstractClassWrapper } from './InterfaceAbstractClass.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface InterfaceAbstractClassProps { }

const InterfaceAbstractClass: FC<InterfaceAbstractClassProps> = () => (
   <InterfaceAbstractClassWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Interface &amp; Abstract Class</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <h4 className="text-align-justify"><strong>Absract Class :</strong></h4>
         <ul className="text-align-justify">
            <li>An abstract method is the one that is declared without an implementation (without braces, and followed by a semicolon).</li>
            <li>Abstract classes can be inherited but they cannot be instantiated.</li>
            <li>It is declared with an abstract keyword. It contains both abstract and non-abstract methods (method with the body).</li>
            <li>An abstract method can have constructors and static methods also.</li>
            <li>In addition, it can have final methods that will force the subclass not to change the body of the method.</li>
            <li>If a method in a class is declared as an abstract method then you will have to make/declare the class as an abstract class.</li>
            <li>When a class inherits an abstract class then its derived class must also be declared as an abstract class.</li>
            <li>If a class inherits an abstract class but the abstract method contained in the base class is overridden in the derived class then there is no need to declare the derived class as an abstract class.</li>
         </ul>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'abstract class aaa {\n'+
               '  abstract void sam() {};\n'+
               '}\n'+
               '\n'+
               'OR\n'+
               '\n'+
               'abstract class aaa {\n'+
               '  abstract void sam() {};\n'+
               '}\n'+
               'abstract class bbb extends aaa {\n'+
               '  //some code\n'+
               '}\n'+
               '\n'+
               'OR\n'+
               '\n'+
               'abstract class aaa {\n'+
               '  abstract void sam() {};\n'+
               '}\n'+
               'class bbb extends aaa {\n'+
               '  public void sam() {\n'+
               '    //some code\n'+
               '  };\n'+
               '}'
            }
         </SyntaxHighlighter>
         <br/>
         <h4 className="text-align-justify"><strong>Interface :</strong></h4>
         <ul className="text-align-justify">
            <li>An interface is a reference type or a collection of abstract methods. It is used to achieve total abstraction.</li>
            <li>Interfaces define what a class must do and not how.</li>
            <li>The interface exposes the features of an object. An object can access the features of another object through an interface.</li>
            <li>In an interface, the inheritance feature is not available.</li>
            <li>We cannot make an object of an interface but we can make a pointer of an interface.</li>
            <li>Java does not support “multiple inheritance”. Multiple Inheritance can only be achieved in Java with the help of interfaces. A class can implement multiple interfaces.</li>
            <li>In order to access the interface methods, the interface must be “implemented” by another class with the implements keyword.</li>
            <li>Interface methods are abstract and public by default.</li>
            <li>The attributes of an interface are by default public, static, and final.</li>
            <li>The interface also represents the IS-A relationship.</li>
            <li>If an interface extends or inherits another interface then it will have to declare the methods of another method at the time of implementation.</li>
            <li>Variables can be declared in an interface but declaration and assignment of those variables have to be done at a time and then those variables become final, its value can’t be changed later.</li>
            <li>When a class implements an interface then, the declared methods in the interface have to be defined in the class. And if not, then declare the class as an abstract class that is implementing the interface.</li>
            <li>Extends followed by implements is the correct format. The reverse is wrong. Eg: class uuu extends ppp implements rrr,ttt</li>
         </ul>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'interface aaa {\n'+
               '  public void sam() {};\n'+
               '}\n'+
               'class bbb implements aaa {\n'+
               '  public void sam() {\n'+
               '    //some code\n'+
               '  }\n'+
               '}\n'+
               '\n'+
               'OR\n'+
               '\n'+
               'interface aaa {\n'+
               '  public void sam() {};\n'+
               '}\n'+
               'abstract class ccc implements aaa {\n'+
               '  //some code\n'+
               '}'
            }
         </SyntaxHighlighter>
      </div>
   </InterfaceAbstractClassWrapper>
);

export default InterfaceAbstractClass;
